import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { canRenderRankIcon } from 'partner360/components/partnerRanks/components/rankIcon/helpers/canRenderRankIcon'
import { selectP360PartnerClasses } from 'partner360/features/p360PartnerFlags'

import { RankIcon } from './components/rankIcon/RankIcon'
import { IPartnerRanksProps } from './models/iPartnerRanksProps'

import styles from './PartnerRanks.module.scss'

export const PartnerRanks: FC<IPartnerRanksProps> = ({ selectedOffering, ranks }) => {
  const partnerRanks = useSelector(selectP360PartnerClasses)

  const appliedRanks = useMemo(() => {
    if (!ranks) {
      return []
    }

    const filteredRanks = partnerRanks.filter((it) => {
      if (!selectedOffering) {
        return true
      }

      return it.Offering === selectedOffering
    })

    return ranks.split(',').filter((rank) => {
      const found = filteredRanks.find((el) => el.PartnerFlag === rank)
      return canRenderRankIcon(found, true)
    })
  }, [partnerRanks, ranks, selectedOffering])

  return (
    <div className={styles.partnerRanks}>
      {appliedRanks.map((rank) => (
        <RankIcon key={rank} partnerFlag={rank} />
      ))}
      {appliedRanks.length === 0 && '-'}
    </div>
  )
}
